'use client';

import { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Barra de progreso superior que muestra el avance de scroll.
 *
 * Importante: framer-motion `useScroll` se conecta al window despues del primer
 * render del cliente. Para evitar que un setState durante la hidratacion dispare
 * el aviso #329 ("Suspense boundary received an update before hydrating") solo
 * montamos el `motion.div` cuando el componente esta hidratado.
 */
export function ScrollProgress() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  if (!mounted) return null;

  return (
    <motion.div
      style={{ scaleX }}
      className="pointer-events-none fixed left-0 right-0 top-0 z-[60] h-0.5 origin-left bg-gradient-to-r from-gold-600 via-gold-glow to-gold-400"
      aria-hidden
    />
  );
}
